import {
  ComponentRef,
  Directive,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Type,
  ViewContainerRef,
} from '@angular/core';
import { LayoutModel } from '@app/models/server/layout.model';

/*import { LoggerService } from '@app/services/util-services/logger.service';*/

@Directive({
  selector: '[appB2bDynamicLoader]',
  standalone: true,
})
export class B2bDynamicLoaderDirective implements OnInit {
  @Input() appLoader!: Type<any>;
  @Input() compData: any;
  @Input() layoutData: LayoutModel;

  @Output() dismissEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() actionApiEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() componentLoadedEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(private vcf: ViewContainerRef) {}

  ngOnInit(): void {
    if (this.appLoader) {
      const componentRef: ComponentRef<any> = this.vcf.createComponent(
        this.appLoader,
      );

      componentRef.instance.compData = this.compData;
      componentRef.instance.layoutData = this.layoutData;

      componentRef.instance.selectEvent?.subscribe((data: any) => {
        this.dismissEvent.emit(data);
      });

      componentRef.instance.actionApiEvent?.subscribe((data: any) => {
        this.actionApiEvent.emit(data);
      });

      this.componentLoadedEvent.emit();
      /*LoggerService.log(
        'Inside B2bDynamicLoaderDirective after component loaded ',
        this.appLoader
      );*/
    } else {
      /*LoggerService.warn('this.appLoader is not defined ', this.appLoader);*/
    }
  }
}
